import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';

// Types
import { UserSuggestion } from 'Shared/types/UserSuggestion.type';
import { FeedbackRecognitionType } from 'Shared/constants/types';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Selectors
import { getFeedbackByUuidV2 } from 'Shared/selectors/Feedbacks.selectors';

// Components
import BaseUserSuggestionItem from './BaseUserSuggestionItem';

type Props = {
  userSuggestion: UserSuggestion;
  className?: string;
};

const FeedbackDraftReminderSuggestion = ({ userSuggestion, className }: Props) => {
  const history = useHistory();

  const feedback: FeedbackRecognitionType = useSelector(state =>
    getFeedbackByUuidV2(state, { feedbackUuid: userSuggestion.suggestablePublicId })
  );

  const handleOnClick = useCallback(() => {
    history.push({
      pathname: PageUrlsUtils.makeEditFeedbackFormUrl(feedback.workspaceUuid, feedback.uuid),
      state: {
        userSuggestionId: userSuggestion.slug,
      },
    });
  }, [history]);

  return (
    <BaseUserSuggestionItem
      userSuggestion={userSuggestion}
      btnLabel="Finish Feedback"
      onClick={handleOnClick}
      className={className}
    />
  );
};

export default FeedbackDraftReminderSuggestion;
